import React, { useEffect, useState } from "react";
import { usePageMeta } from "../seo";
import "../style/project.css";

export default function Projects() {
  usePageMeta({
    title: "Projects",
    description:
      "Open-source security tooling and research projects by Brutal Panda — " +
      "offensive tooling, Windows internals experiments and proof-of-concept code.",
    path: "/projects",
  });

  const [projects, setProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch("/projects/projects.json", { priority: "high" })
      .then(res => res.json())
      .then(data => {
        setProjects(data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error("Failed to load projects", err);
        setIsLoading(false);
      });
  }, []);

  // Filter projects based on search input, most recent first
  const filteredProjects = projects
    .filter(project => {
      const searchLower = searchTerm.toLowerCase();
      return (
        project.title.toLowerCase().includes(searchLower) ||
        project.description.toLowerCase().includes(searchLower) ||
        project.tags.some(tag => tag.toLowerCase().includes(searchLower))
      );
    })
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  const hasResults = filteredProjects.length > 0;

  if (isLoading) {
    return (
      <section id="projects" className="section" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "40vh" }}>
        <div className="pixel-loader"></div>
        <p style={{ marginTop: "20px", color: "var(--accent)" }}>Loading projects...</p>
      </section>
    );
  }

  return (
    <section id="projects" className="section">
      <h3><i className="fas fa-project-diagram"></i> My Projects</h3>

      {/* Search bar */}
      <input
        type="text"
        className="pixel-input"
        placeholder="Search projects by title, description, or tag..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {!hasResults && searchTerm && (
        <div className="no-results">
          <i className="fas fa-search"></i>
          <h3>No projects found</h3>
          <p>Try a different search term</p>
        </div>
      )}

      {/* Projects grid */}
      <div className="projects-grid">
        {filteredProjects.map((project) => (
          <div
            className="project-card"
            key={project.id}
            onClick={() => window.open(project.link, "_blank", "noopener,noreferrer")}
          >
            <h4>{project.title}</h4>
            <div className="date">{project.date}</div>
            <p>{project.description}</p>
            <div className="tags">
              {project.tags.map((tag, index) => (
                <span className="tag" key={index}>{tag}</span>
              ))}
            </div>
            <a
              href={project.link}
              className="pixel-button"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              Check Out
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
